var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { EntryStatusApi, } from 'api-typings/contests/contests';
/**
 * Used on server notifications model since entry-related websocket events
 * sends the status as a text.
 */
export var ContestEntryStatusWebsocketEvent;
(function (ContestEntryStatusWebsocketEvent) {
    ContestEntryStatusWebsocketEvent["WON"] = "Won";
    ContestEntryStatusWebsocketEvent["BOUGHT"] = "Bought";
    ContestEntryStatusWebsocketEvent["ELIMINATED"] = "Eliminated";
    ContestEntryStatusWebsocketEvent["ACTIVE"] = "Active";
    ContestEntryStatusWebsocketEvent["WITHDRAWN"] = "Withdrawn";
})(ContestEntryStatusWebsocketEvent || (ContestEntryStatusWebsocketEvent = {}));
export var CONTEST_ENTRY_IMAGE_FORMATS = [
    'jpeg',
    'jpg',
    'png',
    'gif',
];
export var CONTEST_ENTRY_VIDEO_FORMATS = [
    'mov',
    'mpg',
    'mpeg',
    'avi',
    'flv',
];
export var CONTEST_ENTRY_TEXT_FORMATS = ['pdf'];
export var CONTEST_ENTRY_AWARD_STATUSES = [
    EntryStatusApi.WON,
    EntryStatusApi.WON_CLOSED,
    EntryStatusApi.WON_RUNNER_UP,
    EntryStatusApi.WON_BRONZE,
    EntryStatusApi.WON_SILVER,
    EntryStatusApi.WON_GOLD,
    EntryStatusApi.CHOSEN,
];
/** Set of contest entry statuses allowed to be shown in CVP */
export var VISIBLE_ENTRIES_DEFAULT_FILTER = __spreadArrays([
    EntryStatusApi.WITHDRAWN,
    EntryStatusApi.WITHDRAWN_ELIMINATED,
    EntryStatusApi.ELIMINATED,
    EntryStatusApi.ACTIVE,
    EntryStatusApi.BOUGHT
], CONTEST_ENTRY_AWARD_STATUSES);
export var ContestEntryFileType;
(function (ContestEntryFileType) {
    ContestEntryFileType[ContestEntryFileType["IMAGE"] = 0] = "IMAGE";
    ContestEntryFileType[ContestEntryFileType["VIDEO"] = 1] = "VIDEO";
    ContestEntryFileType[ContestEntryFileType["TEXT"] = 2] = "TEXT";
})(ContestEntryFileType || (ContestEntryFileType = {}));
